import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getInProgressFieldWorks(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS,
    ModulesConfigMap[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS].GET_IN_PROGRESS_FIELD_WORKS,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS].GET_IN_PROGRESS_FIELD_WORKS]: _getInProgressFieldWorks
}